// Tracks the last product-listing URL the user visited so that the product
// detail page can offer a "Back to products" link that returns to the exact
// filtered/sorted/paginated context.

const STORAGE_KEY = "lastListingUrl";

// Paths considered "product listings" — any of these (with their search params)
// should be remembered as a back target. Supports both the new
// language-prefixed clean URLs (/lv/padel-raketes, /en/padel-rackets/...) and
// the legacy query-based URLs while old links are still being followed.
const LISTING_PATTERNS: RegExp[] = [
  // New clean URLs: /<lang>/<typeSlug>[/<brandSlug>]
  /^\/(?:lv|en)\/(?:padel-raketes|padel-apavi|padel-apgerbs|padel-somas|padel-bumbas|padel-aksesuari|padel-rackets|padel-shoes|padel-apparel|padel-bags|padel-balls|padel-accessories)(?:\/|$)/,
  // Sale & legacy
  /^\/(?:lv|en)\/(?:izpardosana|sale)(?:\/|$)/,
  /^\/products(?:\/|\?|$)/,
  /^\/sale(?:\/|\?|$)/,
  /^\/brand-rackets(?:\/|$)/,
  /^\/padel-bumbas(?:\/|$)/,
];

export function isListingPath(pathname: string): boolean {
  return LISTING_PATTERNS.some((re) => re.test(pathname));
}

export function saveListingUrl(url: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, url);
  } catch {
    // ignore
  }
}

export function getListingUrl(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}
